import React from 'react';
import type ProformaJiraIssueFormsDirectEmbedType from '@atlassian/jira-spa-apps-proforma-issue-forms-direct-embed/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProformaIssueFormsDirectEmbed = lazyForPaint<
	typeof ProformaJiraIssueFormsDirectEmbedType
>(
	() =>
		import(
			/* webpackChunkName: "async-proforma-issue-forms-direct-embed", jiraSpaEntry: "async-proforma-issue-forms-direct-embed" */ '@atlassian/jira-spa-apps-proforma-issue-forms-direct-embed'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProformaIssueFormsDirectEmbed}
		pageId="proforma-issue-forms-direct-embed"
		shouldShowSpinner
	/>
);
